var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTeam(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B)",
    fill: "url(#A)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25a7.51 7.51 0 0 0-7.5 7.5v1.875C0 21.661.839 22.5 1.875 22.5h11.25c1.036 0 1.875-.839 1.875-1.875V18.75a7.51 7.51 0 0 0-7.5-7.5zm-3.75 7.5C3.75 16.682 5.432 15 7.5 15s3.75 1.682 3.75 3.75h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.125 5.625C13.125 2.523 10.602 0 7.5 0S1.875 2.523 1.875 5.625 4.398 11.25 7.5 11.25s5.625-2.523 5.625-5.625zM7.5 7.5a1.88 1.88 0 0 1-1.875-1.875A1.88 1.88 0 0 1 7.5 3.75a1.88 1.88 0 0 1 1.875 1.875A1.88 1.88 0 0 1 7.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.5 11.25a7.51 7.51 0 0 0-7.5 7.5v1.875c0 1.036.84 1.875 1.875 1.875h11.25c1.036 0 1.875-.839 1.875-1.875V18.75a7.51 7.51 0 0 0-7.5-7.5zm-3.75 7.5c0-2.068 1.682-3.75 3.75-3.75s3.75 1.682 3.75 3.75h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.125 5.625C46.125 2.523 43.602 0 40.5 0s-5.625 2.523-5.625 5.625 2.523 5.625 5.625 5.625 5.625-2.523 5.625-5.625zM40.5 7.5a1.88 1.88 0 0 1-1.875-1.875A1.88 1.88 0 0 1 40.5 3.75a1.88 1.88 0 0 1 1.875 1.875A1.88 1.88 0 0 1 40.5 7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24 36.75a7.51 7.51 0 0 0-7.5 7.5v1.875c0 1.036.84 1.875 1.875 1.875h11.25c1.036 0 1.875-.839 1.875-1.875V44.25a7.51 7.51 0 0 0-7.5-7.5zm-3.75 7.5c0-2.068 1.682-3.75 3.75-3.75s3.75 1.682 3.75 3.75h-7.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.625 31.125c0-3.102-2.523-5.625-5.625-5.625s-5.625 2.523-5.625 5.625S20.898 36.75 24 36.75s5.625-2.523 5.625-5.625zM24 33a1.88 1.88 0 0 1-1.875-1.875A1.88 1.88 0 0 1 24 29.25a1.88 1.88 0 0 1 1.875 1.875A1.88 1.88 0 0 1 24 33z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.007 33.435c-.609-.902-1.133-1.866-1.556-2.866-.43-1.017-.761-2.082-.982-3.165-.208-1.015-1.198-1.669-2.213-1.461s-1.669 1.198-1.461 2.213c.271 1.325.676 2.629 1.203 3.874.517 1.222 1.157 2.401 1.902 3.504.737 1.092 1.584 2.118 2.518 3.051.732.732 1.919.732 2.652 0s.732-1.919 0-2.652c-.764-.764-1.458-1.605-2.062-2.499z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.745 25.943c-1.016-.208-2.005.447-2.213 1.461-.221 1.083-.552 2.148-.982 3.165-.423 1-.946 1.964-1.556 2.866-.604.894-1.297 1.734-2.062 2.499-.732.732-.732 1.919 0 2.652s1.919.733 2.652 0c.933-.933 1.78-1.959 2.517-3.051a20.63 20.63 0 0 0 1.902-3.504c.527-1.245.931-2.549 1.203-3.874.208-1.014-.447-2.005-1.461-2.213z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.029 4.997A20.5 20.5 0 0 0 24 3.375c-2.783 0-5.485.546-8.029 1.622-.954.403-1.4 1.504-.996 2.457s1.504 1.4 2.457.996c2.079-.879 4.289-1.325 6.568-1.325s4.489.446 6.568 1.325c.954.403 2.054-.043 2.457-.996s-.043-2.054-.996-2.457z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "A",
    x1: 0,
    y1: 24.115,
    x2: 48,
    y2: 24.115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6366f1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#8b5cf6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#d946ef"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "B"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h48v48H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeam);
export default __webpack_public_path__ + "static/media/team.10b9c4d6c0b8fd297824363810303f11.svg";
export { ForwardRef as ReactComponent };